import { AROApiUrl, AROApiKey } from "../utils/config";

export async function aroFetch<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(`${AROApiUrl()}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      "X-API-Key": AROApiKey(),
      ...(options?.headers || {}),
    },
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: "Unknown error" }));
    throw new Error(err.detail || "Request failed");
  }

  return res.json();
}

export async function aroFetchForm<T>(path: string, formData: FormData): Promise<T> {
  const res = await fetch(`${AROApiUrl()}${path}`, {
    method: "POST",
    headers: { "X-API-Key": AROApiKey() },
    body: formData,
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: "Unknown error" }));
    throw new Error(err.detail || "Request failed");
  }

  return res.json();
}

export async function aroFetchBlob(path: string): Promise<Blob> {
  const res = await fetch(`${AROApiUrl()}${path}`, {
    headers: { "X-API-Key": AROApiKey() },
  });

  if (!res.ok) throw new Error("Export failed");
  return res.blob();
}
